class ChatHelpManager {
  handleChatHelp = null;

  changeChatVisibility (visible) {
    if (this.handleChatHelp) {
      this.handleChatHelp(visible)
    }
  }
}

export default new ChatHelpManager()
